module.exports = __webpack_public_path__ + "img/fevend-large-page.b8098fc7.webp";